const SAR_MARK = /^#(\d+(?:\.\d+)?)\s*/;

export function parseSarPrice(title?: string | null): number | null {
  if (!title) return null;
  const match = title.trim().match(SAR_MARK);
  if (!match) return null;
  const value = Number(match[1]);
  return Number.isFinite(value) ? value : null;
}

export function stripSarPrice(title?: string | null): string {
  if (!title || title === 'null') return '';
  return title.replace(SAR_MARK, '').trim();
}

export function withSarPrice(title: string, sarPrice: string | number): string {
  const clean = stripSarPrice(title);
  const amount = String(sarPrice).trim();
  if (amount === '' || Number.isNaN(Number(amount)) || Number(amount) < 0) return clean;
  return `#${amount} ${clean}`.trim();
}
